/* eslint-disable import/no-anonymous-default-export */
export default {
	api_url: process.env.REACT_APP_PRISMIC_API_URL,
	access_token: process.env.REACT_APP_PRISMIC_ACCESS_TOKEN,
};
